import baseApi from "@/api/baseApi";

const api = {
  async getBookingsBarracks() {
    const response = await baseApi({
      method: "get",
      url: `/barracks/bookings`,
    });

    return response.data;
  },

  async getBookingActiveBarracks() {
    const response = await baseApi({
      method: "get",
      url: `/barracks/bookingactive`,
    });

    return response.data;
  },

  async getBookingsBarracksProject(projectId) {
    const response = await baseApi({
      method: "get",
      url: `/barracks/bookings/${projectId}`,
    });

    return response.data;
  },

  async getBookingBarracksAvailableRooms(data) {
    const response = await baseApi({
      method: "post",
      url: `/barracks/booking/availablerooms`,
      data: data,
    });

    return response.data;
  },
  async addBookingBarracks(data) {
    const response = await baseApi({
      method: "post",
      url: `/barracks/booking/add`,
      data: data,
    });

    return response.data;
  },

  async delBookingBarracks(bookingId) {
    const response = await baseApi({
      method: "delete",
      url: `/barracks/booking/del/${bookingId}`,
    });

    return response.data;
  },
};

export default api;
